export const defaultResponseImage = `${location.origin}/assets/default_response_image.jpg`;
